<style scoped>
.item-title {
  padding: 24px;
}
.mu-input {
  min-height: 1px;
  margin-bottom: 0px;
  padding-bottom: 0px;
  width: auto;
}
</style>

<template>
  <div>
    <mu-button small icon @click="onClickBack"><mu-icon value="keyboard_backspace" /></mu-button>
    <mu-container>
      <mu-paper :z-depth="1" v-if="flagFetchedChannel && flagFetchedAdmin && flagFetchedUsers">
        <div>
          <span class="float-right" >
            <mu-text-field v-model="modelSearch" icon="search"></mu-text-field>
          </span>
          <h1 class="item-title">{{$t('admin.title')}}</h1>
        </div>
        <mu-data-table :columns="columns" stripe :data="searched" :no-data-text="$t('empty.noDataTitle')">
          <template slot-scope="scope">
          <td>{{scope.row.name}}</td>
          <td>{{scope.row.email}}</td>
          <td>{{stringRole(scope.row)}}</td>
          <td>
            <span v-if="isCreator(scope.row)">{{$t('admin.isCreator')}}</span>
            <ManagerCheckbox
              :channelId="channel._id"
              :user="scope.row"
              :isAdmin="isAdmin(scope.row)"
              v-else
              />
          </td>
          </template>
        </mu-data-table>
      </mu-paper>
    </mu-container>
  </div>
</template>

<script>
// Components
import ManagerCheckbox from '@/components/Manager/ManagerCheckbox.vue'

// Library
import axios from "axios";

export default {
  name: 'ManagerPage',
  components: {
    ManagerCheckbox
  },
  props: {
    channelId: {
      type: String,
      required: true
    }
  },
  data() {
    return {

      loading: null,

      // Object
      channel: {},
      users: [],
      admin: {},
      
      // Model
      modelSearch: "",

      // Flag
      flagFetchedChannel: false, // Boolean variable for status of admin fetched
      flagFetchedAdmin: false, // Boolean variable for status of admin fetched
      flagFetchedUsers: false, // Boolean variable for status of users fetched
      flagAdmin: false,
    }
  },
  computed: {
    // Flag
    canManage() {
      return this.$store.getters.isAdmin || this.flagAdmin;
    },

    columns() {
      var array = [
        { title: this.$t('profile.fullname'), name: 'name' },
        { title: this.$t('profile.email'), name: 'email' },
        { title: this.$t('profile.role'), name: 'role' },
        { title: this.$t('admin.manage'), name: 'manage' },
      ];
      return array;
    },

    computedUsers() {
      if (!Array.prototype.filter) {
        Array.prototype.filter = function(fun /*, thisp*/) {
        var len = this.length >>> 0;
        if (typeof fun != "function")
        throw new TypeError();

        var res = [];
        var thisp = arguments[1];
        for (var i = 0; i < len; i++) {
          if (i in this) {
          var val = this[i];
          if (fun.call(thisp, val, i, this))
          res.push(val);
          }
        }
        return res;
        };
      }
      return this.users.filter(function (el) {
        return el.roles.includes('teacher') || el.roles.includes('assistant') || el.roles.includes('admin');
      });
    },
    
    searched() {
      if(this.modelSearch.length > 0) {
        return this.searchBy(this.computedUsers, this.modelSearch);
      } else {
        return this.computedUsers;
      }
    },
  },
  created() {

    this.checkPermit();
  },
  methods: {
    // Fetch
    checkPermit() {
      axios.get(this.$store.getters.urlApi + "permit/channel/" + this.channelId, {
        headers: {
          token: this.$store.state.auth.token
        }
        }
      ).then(response => {
        var result = response.data.data.admin;
        if(result) {
          this.fetchChannel();
        } else {

          this.$store.commit('toRoute', {
            path: '/'
          })
        }
      });
    },
    fetchChannel() {
      axios.get(this.$store.getters.urlApi + "channel/" + this.channelId, {
        headers: {
          token: this.$store.state.auth.token
        }
        }
      ).then(response => {
        this.channel = response.data.data.channel
        this.flagFetchedChannel = true;
        this.fetchAdmin();
        this.fetchUsers();

      });
    },
    fetchAdmin() {
      axios.get(this.$store.getters.urlApi + "admin/channel/" + this.channelId, {
        headers: {
          token: this.$store.state.auth.token
        }
        }
      ).then(response => {
        this.admin = response.data.data.admin
        this.flagAdmin = response.data.data.admin.user_ids.includes(this.$store.state.auth.user._id);
        this.flagFetchedAdmin = true;
        if(!this.canManage) {
          this.$router.push({
            name: 'Channel',
            params: {
              channelId: this.channelId
            }
          });
        }
      });
    },
    fetchUsers() {
      axios.get(this.$store.getters.urlApi + "user", {
        headers: {
          token: this.$store.state.auth.token
        }
        }
      ).then(response => {
        this.users = response.data.data.users
        this.flagFetchedUsers = true;
      });
    },
    // Flag
    isAdmin(user) {
      return this.admin.user_ids.includes(user._id);
    },
    isCreator(user) {
      return this.channel.creator_id === user._id;
    },
    show(user) {
      return !user.roles.includes('admin') && user._id !== this.channel.creator_id && (user.roles.includes('teacher') || user.roles.includes('assistant'));
    },
    
    // Event
    onClickBack() {
      this.$router.push({
        name: 'Channel',
        params: {
          channelId: this.channelId
        }
      });
    },

    // String
    stringName(user) {
      if(user.hasOwnProperty('name')) {
        return user.name;
      } else {
        return this.$t('admin.not_specified');
      }
    },
    stringLastActiveAt(user) {
      if(user.hasOwnProperty('last_active_at')) {
        var d = new Date(user.last_active_at.date);
        var delta = Math.round((+new Date - d) / 1000);
        var minute = 60,
          hour = minute * 60,
          day = hour * 24,
          week = day * 7,
          month = day * 30,
          year = day * 356;
        var str = "";
        if (delta < 30) {
          str += this.$t('time.justNow');
        } else if (delta < minute) {
          str += delta + this.$t('time.secondsAgo');
        } else if (delta < 2 * minute) {
          str += this.$t('time.minuteAgo');
        } else if (delta < hour) {
          str += Math.floor(delta / minute) + this.$t('time.minutesAgo');
        } else if (Math.floor(delta / hour) == 1) {
          str += this.$t('time.hourAgo');
        } else if (delta < day) {
          str += Math.floor(delta / hour) + this.$t('time.hoursAgo');
        } else if (delta < day * 2) {
          str += this.$t('time.yesterday');
        } else if (delta < day * 7) {
          str += Math.floor(delta / day) + this.$t('time.daysAgo');
        } else if (delta < month) {
          str += Math.floor(delta / week) + this.$t('time.weeksAgo');
        } else if (delta < year) {
          str += Math.floor(delta / month) + this.$t('time.monthsAgo');
        } else {
          str += Math.floor(delta / year) + this.$t('time.yearsAgo');
        }
        return str;
      } else {
        return this.$t('admin.no_record');
      }
    },
    stringRole(user) {
      return user.roles.map(x => x.charAt(0).toUpperCase() + x.slice(1)).join(', ');
    },
    
    toLower(text) {
      if(text)
        return text.toString().toLowerCase();
      else
        return "";
    },
    searchBy(items, term) {
      if (term) {
        return items.filter(item =>
        this.toLower(item.name).includes(this.toLower(term.trim())) ||
        this.toLower(item.email).includes(this.toLower(term.trim())) ||
        this.toLower(item.username).includes(this.toLower(term.trim()))
        )
      }

      return items
    },
  },
}
</script>
